import {IItemContent} from "@connox/typescript-library";
import React, {Suspense, useEffect, useState} from "react";
import ReactDOM from "react-dom";
import {retrieveBoughtTogether} from "./CrossSelling";
import {useCustomerSelector} from "../../../store";
import {useTranslation} from "react-i18next";
import ErrorBoundary from "../../utils/ErrorBoundary";
import SwiperConstruct from "./SwiperConstruct";
import ListItemCard from "../productList/ListItemCard";

export let localCache: IItemContent[] | undefined;

const BoughtTogetherPortalComponent: React.FC<{itemId?: string}> = ({itemId}) => {
  const {t} = useTranslation();
  const {customer} = useCustomerSelector();
  const [items, setItems] = useState<IItemContent[]>([]);

  useEffect(() => {
    if (!itemId) {
      return;
    }
    void retrieveBoughtTogether(itemId, customer).then((itemContent) => {
      localCache = itemContent;
      setItems(itemContent);
    });
  }, []);

  if (!items.length) {
    return null;
  }

  return <SwiperConstruct title={t("product.customersAlsoBought")}>
    {items.map((item, key) => {
      return (<ListItemCard key={key} item={item} />);
    })}
  </SwiperConstruct>;
};

const BoughtTogetherPortal: React.FC<{itemId?: string}> = ({itemId}) => {
  const parentCategoriesElement = document.getElementById("PABoughtTogether");

  if (!parentCategoriesElement) {
    return null;
  }

  return ReactDOM.createPortal(
    <Suspense fallback={null}>
      <ErrorBoundary fallback={null} occurrence="BoughtTogetherPortal PDP portal error">
        <BoughtTogetherPortalComponent itemId={itemId} />
      </ErrorBoundary>
    </Suspense>,
    parentCategoriesElement,
  );
};

export default BoughtTogetherPortal;
